import { render, staticRenderFns } from "./PagedAlbums.vue?vue&type=template&id=9e4cfede&lang=pug&"
import script from "./PagedAlbums.vue?vue&type=script&lang=js&"
export * from "./PagedAlbums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports